// RequireAuth.js
import { useAuthenticator } from "@aws-amplify/ui-react"
import { ReactElement } from "react"
import { useLocation, Navigate } from "react-router-dom"

import { IS_AUTHENTICATED } from "../constants/generalConstants"
import { LOGIN } from "../router/routes"

type RequireAuthProps = {
    children: ReactElement
}
/**
 * Wraps components / routes that demand a user be authenticated. If user
 * is not authenticated, it triggers a redirect to the login screen.
 *
 * @returns
 */
const RequireAuth = ({ children }: RequireAuthProps): ReactElement => {
    const location = useLocation()
    const { route } = useAuthenticator((context) => [context.route])
    if (route !== IS_AUTHENTICATED) {
        return <Navigate to={LOGIN} state={{ from: location }} replace />
    }
    return children
}
export default RequireAuth
